<script>
    export let categories;

    export let activeCategoryIdx;

    function updateActive(e, i) {
        activeCategoryIdx = i;
        e.preventDefault()
        return false
    }
</script>

<style>
    ul.nav {
        float: left;
    }
</style>

<ul class="nav nav-tabs nav-tabs-default flex-1">
    {#each categories as category, i}
        <li role="presentation" class:active={i == activeCategoryIdx}>
        <a href="?tab={i}" data-tab-index={i} on:click={(e) => updateActive(e, i)}>{ category.title }</a>
        </li>
    {/each}
</ul>
